import { AxModal, AxDropdown, IAxDropdownOptions, AxFormValidation, AxInput, IAxFormValidationOptions } from "@axess/limestone";
import { PriceHelper } from "../../../../Lib/Helper/PriceHelper";
import Alpine, { AlpineComponent } from "alpinejs";
import { AxLoad } from "../../../../Lib/AxSystem/AxLoad";
import * as Rental from "../RiderDetailsModule";
import * as models from "../RiderDetailsModelBundle";
import { CheckAllowedRentalIItemsService } from "../../Services/CheckAllowedRentalIItemsService";
import { ConfigDefinition, ConfigHelper } from "../../../../Lib/Helper/Config/ConfigHelper";

export class RiderSelection {
    private riderDetailsModule: Rental.RiderDetailsModule;

    private personDropDown = new AxDropdown();

    private priceHelper: PriceHelper;

    private headerProdName: HTMLDivElement;
    private headerProdPrice: HTMLDivElement;
    private innerArea: HTMLDivElement;
    private alertBanner: HTMLDivElement;

    private personSelectionDateOfBirth: HTMLInputElement;
    private personSelectionMail: HTMLInputElement;

    private mobileCancelBtn: HTMLButtonElement;
    private mobileSaveBtn: HTMLButtonElement;

    constructor() {
        this.riderDetailsModule = AxLoad.GetModule<Rental.RiderDetailsModule>("RiderDetailsModule");
        Alpine.start();
        this.priceHelper = new PriceHelper(null, true);

        this.initElements();
        this.initMobileButtons();
        this.initPersonDropDown();
    }

    initElements() {
        this.alertBanner = document.getElementById('savePersonDataAlert') as HTMLDivElement;
        this.personSelectionDateOfBirth = document.getElementsByClassName('rental_rider_details__person-selection-portlet-dateOfBirth')[0] as HTMLInputElement;
        this.personSelectionMail = document.getElementsByClassName('rental_rider_details__person-selection-portlet-mail')[0] as HTMLInputElement;
        this.headerProdName = document.getElementsByClassName('rental_detail_rider__right_container-productName')[0] as HTMLDivElement;
        this.headerProdPrice = document.getElementsByClassName('rental_detail_rider__right_container-productPrice')[0] as HTMLDivElement;
    }

    resetDrownDown() {
        this.personDropDown.resetSelection();
    }

    resetPortlet() {
        this.resetSelectedPersonDataTexts();
        this.personDropDown.resetSelection();
    }

    setDataAfterSelect(productAndRiderDetails: models.ProductAndRiderDetails) {
        this.setDateOfBirthText(productAndRiderDetails.riderData.dateOfBirth);
        this.setEmailText(productAndRiderDetails.riderData.customerEmail);
        this.personDropDown.setValue(productAndRiderDetails.riderData.customerName);
    }

    private initPersonDropDown() {
        this.personDropDown = new AxDropdown();

        this.personDropDown.init(`.rental_rider_details__person-dropdown`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {                    
                    const accountId = parseInt(this.personDropDown.getValue().toString());

                    const currentAccountId = this.riderDetailsModule
                        .getActiveProductPortlet()
                        .getProductAndRiderDetails()?.customerAccountNr;

                    if (accountId === currentAccountId) {                        
                        return;
                    }

                    if (this.riderDetailsModule.getActiveProductPortlet().getProductAndRiderDetails().includedPackageItems.length === 0) {
                        ConfigHelper.getBoolConfigValue(ConfigDefinition.RentalIsAllowedActivated, (rentalIsAllowedActivated) => {
                            if (rentalIsAllowedActivated) {
                                this.checkIfRentalIsAllowed(accountId)
                                    .then(rentalAllowed => {
                                        if (rentalAllowed) {
                                            this.riderDetailsModule.loadAccountData(accountId);
                                        } else {                                            
                                            this.resetPortlet();                                            
                                            this.riderDetailsModule
                                                .getActiveProductPortlet()
                                                .setUserNotSelectedState();
                                        }
                                    });
                            } else {
                                this.riderDetailsModule.loadAccountData(accountId);
                            }
                        });

                    } else {
                        this.riderDetailsModule.loadAccountData(accountId);
                    }                    
                }
            });
    }

    private async checkIfRentalIsAllowed(accountId: number): Promise<boolean> {
        const checkAllowedRentalIItemsService = CheckAllowedRentalIItemsService.getInstance();

        try {
            const rentalAllowedStatus = await checkAllowedRentalIItemsService.checkIfItemIsAllowedForPerson(accountId);

            if (!rentalAllowedStatus.isAllowed) {
                this.showAlertBanner(rentalAllowedStatus.errorMessage, 'danger');
                return false;
            }

            return true;

        } catch (error) {
            console.error('An error occurred:', error);
            return false;
        }
    }

    showAlertBanner(text: string, mode: 'success' | 'danger') {
        this.alertBanner.querySelectorAll('span')[0].innerHTML = text;
        this.alertBanner.classList.remove('hidden');
        this.alertBanner.classList.toggle('ax-alert--success', mode === "success");
        this.alertBanner.classList.toggle('ax-alert--danger', mode === "danger");
    }

    hideAlertBanner() {
        this.alertBanner.classList.add('hidden');
    }

    setHeaderValues(productName: string, price: number) {
        this.headerProdName.innerHTML = productName;
        this.headerProdPrice.innerHTML = this.priceHelper.GetPriceStringWithDecimalDivisorCalced(price);
    }

    setSelectedPersonDataTexts(dateOdBirth: string, email: string) {
        this.setDateOfBirthText(dateOdBirth);
        this.setEmailText(email);
    }

    resetSelectedPersonDataTexts() {
        this.setDateOfBirthText("");
        this.setEmailText("");
    }

    showMobilePersonSelection() {
        this.innerArea = document.getElementsByClassName('rental_detail_rider__right_container-inner')[0] as HTMLDivElement;
        this.innerArea.classList.add('show-mobile');
    }

    private setDateOfBirthText(text: string) {
        this.personSelectionDateOfBirth.value = text;
    }

    private setEmailText(text: string) {
        this.personSelectionMail.value = text;
    }

    private initMobileButtons() {
        this.mobileSaveBtn = document.getElementsByClassName('rental_detail_rider__btn-mobile-save')[0] as HTMLButtonElement;

        this.mobileSaveBtn.addEventListener("click",
            x => {
                this.innerArea.classList.remove('show-mobile');
                this.riderDetailsModule.getActiveProductPortlet().checkFormValidityAndSetStates();
            });

        this.mobileCancelBtn = document.getElementsByClassName('rental_detail_rider__btn-mobile-cancel')[0] as HTMLButtonElement;

        this.mobileCancelBtn.addEventListener("click",
            x => {
                this.innerArea.classList.remove('show-mobile');
                this.riderDetailsModule.getActiveProductPortlet().checkFormValidityAndSetStates();
            });
    }
}



